import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { useAuthStore } from './store/authStore'
import PWAInstallPrompt from './components/PWAInstallPrompt'
import { useBusSync } from './hooks/useBusSync'
import { useVisibilityPause } from './hooks/useVisibilityPause'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60_000,  // 10 min — serve from cache, background refresh after
      gcTime:    60 * 60_000,  // keep in memory 1 hour (switching back to a symbol is instant)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

function AppInner() {
  const init = useAuthStore((s) => s.init)
  useEffect(() => init(), [init])
  useBusSync()
  useVisibilityPause()
  return (
    <>
      <RouterProvider router={router} />
      <PWAInstallPrompt />
    </>
  )
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppInner />
    </QueryClientProvider>
  )
}
